import { LogTypesString } from '@api/store/logs/types';
import { CustomTable, palette } from '@dev/ee-components';
import { isEmpty } from 'lodash-es';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { isLogsScreen } from '../../../helperFunctions';

const TableContainer = styled.div`
    border-bottom: 1px solid ${palette.gray[3]};
    & .MuiTableCell-root.MuiTableCell-body {
        font-weight: 400;
        & .hideCustomTable {
            position: relative;
            z-index: 1;
        }
    }
    & .MuiTableCell-root.MuiTableCell-alignRight {
        padding-right: 40px !important;
    }
    & .MuiTableBody-root > tr:first-child {
        & th,
        td {
            border-top: none;
        }
    }
    & tr > td:nth-child(4) {
        vertical-align: baseline;
        padding-top: 16px;
    }
    & th.MuiTableCell-head {
        z-index: 1;
    }
`;

const columnWidth: Record<string, string> = {
    to: '45%',
    createDate: '20%',
    event: '15%',
    bouncetype: '20%',
    icon: '7%',
};
interface DesktopLogsTableInterface {
    rows: any;
    headers: any;
    isLoading: boolean;
    infiniteScrollProps: {
        next(): void;
        hasMore: boolean;
        loader: JSX.Element;
        dataLength: number;
    };
}

export const DesktopLogsTable: FC<DesktopLogsTableInterface> = ({
    rows,
    headers,
    infiniteScrollProps,
    isLoading,
}: DesktopLogsTableInterface): JSX.Element => {
    const { t } = useTranslation();
    const { logType } = useParams<{ logType: LogTypesString }>();

    return (
        <TableContainer>
            <CustomTable
                disableRowClick
                disableFirstRowBorderTop
                hideCheckboxes
                stickyHeader={false}
                rows={rows}
                headers={headers}
                columnsWidth={{ ...columnWidth, ...(isLogsScreen(LogTypesString.SMS, logType) ? { to: '55%' } : {}) }}
                isEmpty={!isLoading && isEmpty(rows)}
                emptyStateProps={{ text: t('thereisnodatatodisplay') }}
                infiniteScrollProps={infiniteScrollProps}
            />
        </TableContainer>
    );
};
